'use client';

import { useEffect, useState } from 'react';
import { configLightboxSize } from '@/app/lib/utils/helpers';
import FigureStatement from './figure-statement';

interface Props {
  src: string;
  alt: string;
  lightboxPortalId: string;
}

export default function FigureStatementContainer({
  src,
  alt,
  lightboxPortalId
}: Props) {
  const { lightboxWidths, lightboxHeights } = configLightboxSize(src);

  const [lightboxPortal, setLightboxPortal] = useState<
    HTMLElement | null | undefined
  >(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setLightboxPortal(document.getElementById(lightboxPortalId));
  }, [lightboxPortalId]);

  return (
    <FigureStatement
      src={src}
      alt={alt}
      lightboxWidths={lightboxWidths}
      lightboxHeights={lightboxHeights}
      open={open}
      setOpen={setOpen}
      lightboxPortal={lightboxPortal}
    />
  );
}
